import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AppliedCoupon = {
  __typename?: 'AppliedCoupon';
  code: Scalars['String']['output'];
  discount: Price;
  displayName: Scalars['String']['output'];
  expiryDate: Scalars['String']['output'];
  type: CouponType;
};

export type AssignedCoupon = {
  __typename?: 'AssignedCoupon';
  code: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  expiryDate: Scalars['String']['output'];
  type: CouponType;
};

export type AssignedCoupons = {
  __typename?: 'AssignedCoupons';
  autoApplied: Scalars['Boolean']['output'];
  coupons: Array<Maybe<AssignedCoupon>>;
};

/** Contains all the fields that belong to the overall Cart entity. */
export type Cart = {
  __typename?: 'Cart';
  appliedCoupon?: Maybe<AppliedCoupon>;
  lineItems: Array<LineItem>;
  messages: Array<Message>;
  summary: Summary;
};

/**
 * Contains the fields belong to an error for cart
 * Represents an error that happens during execution of a cart mutation
 */
export type CartUserError = UserError & {
  __typename?: 'CartUserError';
  code: Scalars['Int']['output'];
  field: Array<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum CouponType {
  Amount = 'AMOUNT',
  FreeSample = 'FREE_SAMPLE',
  FreeShipping = 'FREE_SHIPPING',
  GiftCertificate = 'GIFT_CERTIFICATE',
  PercentOff = 'PERCENT_OFF',
  VariablePercentOff = 'VARIABLE_PERCENT_OFF'
}

export type DeliveryDates = {
  __typename?: 'DeliveryDates';
  express: DeliveryDetail;
  standard: DeliveryDetail;
};

export type DeliveryDetail = DeliveryTimeFrame | LastOrderByDate;

export type DeliveryTimeFrame = {
  __typename?: 'DeliveryTimeFrame';
  earliest: Scalars['String']['output'];
  latest: Scalars['String']['output'];
};

/**
 * Contains the fields relating to the inventory item that the line item
 * relates to
 */
export type Details = {
  __typename?: 'Details';
  blankItemId?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  inventoryItemId?: Maybe<Scalars['String']['output']>;
  marketingProductTypeId?: Maybe<Scalars['String']['output']>;
  marketingSku?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Price>;
  productTypeId?: Maybe<Scalars['String']['output']>;
  productUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Contains the fields for undiscounted shipping options */
export type EstimatedShipping = {
  __typename?: 'EstimatedShipping';
  express?: Maybe<PriceWithTax>;
  standard: PriceWithTax;
};

export type LastOrderByDate = {
  __typename?: 'LastOrderByDate';
  daysLeft: Scalars['Int']['output'];
  targetDate: Scalars['String']['output'];
};

/** Contains all the fields relating to an individual line item */
export type LineItem = {
  __typename?: 'LineItem';
  details: Details;
  gaCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDigital?: Maybe<Scalars['Boolean']['output']>;
  isQuantityEditable?: Maybe<Scalars['Boolean']['output']>;
  quantity: Scalars['Int']['output'];
  total?: Maybe<Price>;
  totalShipping?: Maybe<Price>;
  undiscountedTotal?: Maybe<Price>;
  work?: Maybe<Work>;
};

export type Message = {
  __typename?: 'Message';
  actionUrl?: Maybe<Scalars['String']['output']>;
  applied: Scalars['Boolean']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  severity: MessageSeverity;
  text?: Maybe<Scalars['String']['output']>;
  type: MessageType;
};

export enum MessageSeverity {
  Error = 'ERROR',
  Information = 'INFORMATION',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export enum MessageType {
  DiscountShipping = 'DISCOUNT_SHIPPING',
  DiscountSitewide = 'DISCOUNT_SITEWIDE',
  DiscountVolume = 'DISCOUNT_VOLUME',
  ExpiredProductRemoval = 'EXPIRED_PRODUCT_REMOVAL',
  FlatRateShippingApplied = 'FLAT_RATE_SHIPPING_APPLIED',
  FreeShippingOnProductApplied = 'FREE_SHIPPING_ON_PRODUCT_APPLIED',
  NonsaleableProductRemoval = 'NONSALEABLE_PRODUCT_REMOVAL',
  ProductWarning = 'PRODUCT_WARNING'
}

/** The mutation root of this schema */
export type Mutation = {
  __typename?: 'Mutation';
  couponCodeApply: CouponCodeApplyResult;
  couponCodeRemove: CouponCodeRemoveResult;
  updateLineItem?: Maybe<UpdateLineItemResult>;
  updateShippingPreference: Scalars['Boolean']['output'];
};


/** The mutation root of this schema */
export type MutationCouponCodeApplyArgs = {
  input: CouponCodeApplyInput;
};


/** The mutation root of this schema */
export type MutationUpdateLineItemArgs = {
  input: UpdateLineItemInput;
};


/** The mutation root of this schema */
export type MutationUpdateShippingPreferenceArgs = {
  input: ShippingPreferenceInput;
};

export type Price = {
  __typename?: 'Price';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

export type PriceWithTax = {
  __typename?: 'PriceWithTax';
  amountExTax: Scalars['Float']['output'];
  price: Price;
  tax: Tax;
};

/** The query root of this schema */
export type Query = {
  __typename?: 'Query';
  cart?: Maybe<Cart>;
  deliveryDates: DeliveryDates;
  user: User;
};


/** The query root of this schema */
export type QueryCartArgs = {
  shippingAddress?: InputMaybe<ShippingAddressInput>;
};


/** The query root of this schema */
export type QueryDeliveryDatesArgs = {
  countryCode: Scalars['String']['input'];
  productTypeIds: Scalars['String']['input'];
  timezoneOffset: Scalars['String']['input'];
};

export type Shipping = {
  __typename?: 'Shipping';
  countryCode: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  estimated: EstimatedShipping;
  selected: ShippingSelected;
  totals: Totals;
};

/** Contains the input fields for the cart query */
export type ShippingAddressInput = {
  countryCode: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export enum ShippingMethod {
  Express = 'EXPRESS',
  Standard = 'STANDARD'
}

/** Contains the input fields for updateShippingPreference mutation */
export type ShippingPreferenceInput = {
  preference: ShippingMethod;
};

export type ShippingSelected = {
  __typename?: 'ShippingSelected';
  estimatedCost: PriceWithTax;
  method: ShippingMethod;
};

/**
 * Contains the fields relating to the aggregation of the line items in the
 * cart
 */
export type Summary = {
  __typename?: 'Summary';
  digitalProductsOnly: Scalars['Boolean']['output'];
  isTaxComputed: Scalars['Boolean']['output'];
  lineItemsCount: Scalars['Int']['output'];
  shipping: Shipping;
  showTaxSeparately: Scalars['Boolean']['output'];
  subtotal: Price;
  tax?: Maybe<Tax>;
  total: Price;
  undiscountedSubtotal: Price;
};

export type Tax = {
  __typename?: 'Tax';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Totals = {
  __typename?: 'Totals';
  express?: Maybe<Price>;
  standard: Price;
};

/** Contains the input fields for updateLineItem mutation */
export type UpdateLineItemInput = {
  id: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** Contains the response fields for updateLineItem mutation */
export type UpdateLineItemResult = {
  __typename?: 'UpdateLineItemResult';
  cart?: Maybe<Cart>;
  cartUserErrors: Array<CartUserError>;
};

export type User = {
  __typename?: 'User';
  assignedCoupons?: Maybe<AssignedCoupons>;
};

export type UserError = {
  code: Scalars['Int']['output'];
  field: Array<Scalars['String']['output']>;
};

/** Contains the fields relating to the work that is attached to the line item. */
export type Work = {
  __typename?: 'Work';
  artistName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

/** Contains the input fields for couponCodeApply mutation */
export type CouponCodeApplyInput = {
  couponCode: Scalars['String']['input'];
};

/** Contains the response fields for couponCodeApply mutation */
export type CouponCodeApplyResult = {
  __typename?: 'couponCodeApplyResult';
  cart?: Maybe<Cart>;
  cartUserErrors: Array<CartUserError>;
};

/** Contains the response fields for couponCodeRemove mutation */
export type CouponCodeRemoveResult = {
  __typename?: 'couponCodeRemoveResult';
  cart?: Maybe<Cart>;
};

export type CartFieldsFragment = { __typename?: 'Cart', lineItems: Array<{ __typename?: 'LineItem', id: string, isQuantityEditable?: boolean | null, isDigital?: boolean | null, gaCode?: string | null, quantity: number, total?: { __typename?: 'Price', amount: number, currency: string } | null, totalShipping?: { __typename?: 'Price', amount: number, currency: string } | null, undiscountedTotal?: { __typename?: 'Price', amount: number, currency: string } | null, details: { __typename?: 'Details', options?: string | null, type?: string | null, imageUrl?: string | null, inventoryItemId?: string | null, blankItemId?: string | null, marketingProductTypeId?: string | null, marketingSku?: string | null, productTypeId?: string | null, productUrl?: string | null, price?: { __typename?: 'Price', amount: number, currency: string } | null }, work?: { __typename?: 'Work', id: string, title?: string | null, artistName?: string | null } | null }>, summary: { __typename?: 'Summary', showTaxSeparately: boolean, lineItemsCount: number, isTaxComputed: boolean, digitalProductsOnly: boolean, tax?: { __typename?: 'Tax', amount: number, currency: string, type: string } | null, total: { __typename?: 'Price', amount: number, currency: string }, subtotal: { __typename?: 'Price', amount: number, currency: string }, undiscountedSubtotal: { __typename?: 'Price', amount: number, currency: string }, shipping: { __typename?: 'Shipping', countryCode: string, countryName: string, estimated: { __typename?: 'EstimatedShipping', standard: { __typename?: 'PriceWithTax', amountExTax: number, price: { __typename?: 'Price', amount: number, currency: string }, tax: { __typename?: 'Tax', amount: number, currency: string, type: string } }, express?: { __typename?: 'PriceWithTax', amountExTax: number, price: { __typename?: 'Price', amount: number, currency: string }, tax: { __typename?: 'Tax', amount: number, currency: string, type: string } } | null }, selected: { __typename?: 'ShippingSelected', method: ShippingMethod, estimatedCost: { __typename?: 'PriceWithTax', amountExTax: number, price: { __typename?: 'Price', amount: number, currency: string }, tax: { __typename?: 'Tax', amount: number, currency: string, type: string } } }, totals: { __typename?: 'Totals', standard: { __typename?: 'Price', amount: number, currency: string }, express?: { __typename?: 'Price', amount: number, currency: string } | null } } }, appliedCoupon?: { __typename?: 'AppliedCoupon', code: string, type: CouponType, displayName: string, expiryDate: string, discount: { __typename?: 'Price', currency: string, amount: number } } | null, messages: Array<{ __typename?: 'Message', actionUrl?: string | null, applied: boolean, severity: MessageSeverity, text?: string | null, type: MessageType, productName?: string | null }> };

export type CartUserErrorFieldsFragment = { __typename?: 'CartUserError', code: number, field: Array<string>, message?: string | null };

export type GetCartQueryVariables = Exact<{
  shippingAddress?: InputMaybe<ShippingAddressInput>;
}>;


export type GetCartQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', lineItems: Array<{ __typename?: 'LineItem', id: string, isQuantityEditable?: boolean | null, isDigital?: boolean | null, gaCode?: string | null, quantity: number, total?: { __typename?: 'Price', amount: number, currency: string } | null, totalShipping?: { __typename?: 'Price', amount: number, currency: string } | null, undiscountedTotal?: { __typename?: 'Price', amount: number, currency: string } | null, details: { __typename?: 'Details', options?: string | null, type?: string | null, imageUrl?: string | null, inventoryItemId?: string | null, blankItemId?: string | null, marketingProductTypeId?: string | null, marketingSku?: string | null, productTypeId?: string | null, productUrl?: string | null, price?: { __typename?: 'Price', amount: number, currency: string } | null }, work?: { __typename?: 'Work', id: string, title?: string | null, artistName?: string | null } | null }>, summary: { __typename?: 'Summary', showTaxSeparately: boolean, lineItemsCount: number, isTaxComputed: boolean, digitalProductsOnly: boolean, tax?: { __typename?: 'Tax', amount: number, currency: string, type: string } | null, total: { __typename?: 'Price', amount: number, currency: string }, subtotal: { __typename?: 'Price', amount: number, currency: string }, undiscountedSubtotal: { __typename?: 'Price', amount: number, currency: string }, shipping: { __typename?: 'Shipping', countryCode: string, countryName: string, estimated: { __typename?: 'EstimatedShipping', standard: { __typename?: 'PriceWithTax', amountExTax: number, price: { __typename?: 'Price', amount: number, currency: string }, tax: { __typename?: 'Tax', amount: number, currency: string, type: string } }, express?: { __typename?: 'PriceWithTax', amountExTax: number, price: { __typename?: 'Price', amount: number, currency: string }, tax: { __typename?: 'Tax', amount: number, currency: string, type: string } } | null }, selected: { __typename?: 'ShippingSelected', method: ShippingMethod, estimatedCost: { __typename?: 'PriceWithTax', amountExTax: number, price: { __typename?: 'Price', amount: number, currency: string }, tax: { __typename?: 'Tax', amount: number, currency: string, type: string } } }, totals: { __typename?: 'Totals', standard: { __typename?: 'Price', amount: number, currency: string }, express?: { __typename?: 'Price', amount: number, currency: string } | null } } }, appliedCoupon?: { __typename?: 'AppliedCoupon', code: string, type: CouponType, displayName: string, expiryDate: string, discount: { __typename?: 'Price', currency: string, amount: number } } | null, messages: Array<{ __typename?: 'Message', actionUrl?: string | null, applied: boolean, severity: MessageSeverity, text?: string | null, type: MessageType, productName?: string | null }> } | null };

export type GetDeliveryDatesQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
  productTypeIds: Scalars['String']['input'];
  timezoneOffset: Scalars['String']['input'];
}>;


export type GetDeliveryDatesQuery = { __typename?: 'Query', deliveryDates: { __typename?: 'DeliveryDates', standard:
      | { __typename?: 'DeliveryTimeFrame', earliest: string, latest: string }
      | { __typename?: 'LastOrderByDate', targetDate: string, daysLeft: number }
    , express:
      | { __typename?: 'DeliveryTimeFrame', earliest: string, latest: string }
      | { __typename?: 'LastOrderByDate', targetDate: string, daysLeft: number }
     } };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', user: { __typename?: 'User', assignedCoupons?: { __typename?: 'AssignedCoupons', autoApplied: boolean, coupons: Array<{ __typename?: 'AssignedCoupon', code: string, type: CouponType, displayName: string, expiryDate: string } | null> } | null } };

export type CouponCodeApplyMutationVariables = Exact<{
  input: CouponCodeApplyInput;
}>;


export type CouponCodeApplyMutation = { __typename?: 'Mutation', couponCodeApply: { __typename?: 'couponCodeApplyResult', cart?: { __typename?: 'Cart', lineItems: Array<{ __typename?: 'LineItem', id: string, isQuantityEditable?: boolean | null, isDigital?: boolean | null, gaCode?: string | null, quantity: number, total?: { __typename?: 'Price', amount: number, currency: string } | null, totalShipping?: { __typename?: 'Price', amount: number, currency: string } | null, undiscountedTotal?: { __typename?: 'Price', amount: number, currency: string } | null, details: { __typename?: 'Details', options?: string | null, type?: string | null, imageUrl?: string | null, inventoryItemId?: string | null, blankItemId?: string | null, marketingProductTypeId?: string | null, marketingSku?: string | null, productTypeId?: string | null, productUrl?: string | null, price?: { __typename?: 'Price', amount: number, currency: string } | null }, work?: { __typename?: 'Work', id: string, title?: string | null, artistName?: string | null } | null }>, summary: { __typename?: 'Summary', showTaxSeparately: boolean, lineItemsCount: number, isTaxComputed: boolean, digitalProductsOnly: boolean, tax?: { __typename?: 'Tax', amount: number, currency: string, type: string } | null, total: { __typename?: 'Price', amount: number, currency: string }, subtotal: { __typename?: 'Price', amount: number, currency: string }, undiscountedSubtotal: { __typename?: 'Price', amount: number, currency: string }, shipping: { __typename?: 'Shipping', countryCode: string, countryName: string, estimated: { __typename?: 'EstimatedShipping', standard: { __typename?: 'PriceWithTax', amountExTax: number, price: { __typename?: 'Price', amount: number, currency: string }, tax: { __typename?: 'Tax', amount: number, currency: string, type: string } }, express?: { __typename?: 'PriceWithTax', amountExTax: number, price: { __typename?: 'Price', amount: number, currency: string }, tax: { __typename?: 'Tax', amount: number, currency: string, type: string } } | null }, selected: { __typename?: 'ShippingSelected', method: ShippingMethod, estimatedCost: { __typename?: 'PriceWithTax', amountExTax: number, price: { __typename?: 'Price', amount: number, currency: string }, tax: { __typename?: 'Tax', amount: number, currency: string, type: string } } }, totals: { __typename?: 'Totals', standard: { __typename?: 'Price', amount: number, currency: string }, express?: { __typename?: 'Price', amount: number, currency: string } | null } } }, appliedCoupon?: { __typename?: 'AppliedCoupon', code: string, type: CouponType, displayName: string, expiryDate: string, discount: { __typename?: 'Price', currency: string, amount: number } } | null, messages: Array<{ __typename?: 'Message', actionUrl?: string | null, applied: boolean, severity: MessageSeverity, text?: string | null, type: MessageType, productName?: string | null }> } | null, cartUserErrors: Array<{ __typename?: 'CartUserError', code: number, field: Array<string>, message?: string | null }> } };

export type CouponCodeRemoveMutationVariables = Exact<{ [key: string]: never; }>;


export type CouponCodeRemoveMutation = { __typename?: 'Mutation', couponCodeRemove: { __typename?: 'couponCodeRemoveResult', cart?: { __typename?: 'Cart', lineItems: Array<{ __typename?: 'LineItem', id: string, isQuantityEditable?: boolean | null, isDigital?: boolean | null, gaCode?: string | null, quantity: number, total?: { __typename?: 'Price', amount: number, currency: string } | null, totalShipping?: { __typename?: 'Price', amount: number, currency: string } | null, undiscountedTotal?: { __typename?: 'Price', amount: number, currency: string } | null, details: { __typename?: 'Details', options?: string | null, type?: string | null, imageUrl?: string | null, inventoryItemId?: string | null, blankItemId?: string | null, marketingProductTypeId?: string | null, marketingSku?: string | null, productTypeId?: string | null, productUrl?: string | null, price?: { __typename?: 'Price', amount: number, currency: string } | null }, work?: { __typename?: 'Work', id: string, title?: string | null, artistName?: string | null } | null }>, summary: { __typename?: 'Summary', showTaxSeparately: boolean, lineItemsCount: number, isTaxComputed: boolean, digitalProductsOnly: boolean, tax?: { __typename?: 'Tax', amount: number, currency: string, type: string } | null, total: { __typename?: 'Price', amount: number, currency: string }, subtotal: { __typename?: 'Price', amount: number, currency: string }, undiscountedSubtotal: { __typename?: 'Price', amount: number, currency: string }, shipping: { __typename?: 'Shipping', countryCode: string, countryName: string, estimated: { __typename?: 'EstimatedShipping', standard: { __typename?: 'PriceWithTax', amountExTax: number, price: { __typename?: 'Price', amount: number, currency: string }, tax: { __typename?: 'Tax', amount: number, currency: string, type: string } }, express?: { __typename?: 'PriceWithTax', amountExTax: number, price: { __typename?: 'Price', amount: number, currency: string }, tax: { __typename?: 'Tax', amount: number, currency: string, type: string } } | null }, selected: { __typename?: 'ShippingSelected', method: ShippingMethod, estimatedCost: { __typename?: 'PriceWithTax', amountExTax: number, price: { __typename?: 'Price', amount: number, currency: string }, tax: { __typename?: 'Tax', amount: number, currency: string, type: string } } }, totals: { __typename?: 'Totals', standard: { __typename?: 'Price', amount: number, currency: string }, express?: { __typename?: 'Price', amount: number, currency: string } | null } } }, appliedCoupon?: { __typename?: 'AppliedCoupon', code: string, type: CouponType, displayName: string, expiryDate: string, discount: { __typename?: 'Price', currency: string, amount: number } } | null, messages: Array<{ __typename?: 'Message', actionUrl?: string | null, applied: boolean, severity: MessageSeverity, text?: string | null, type: MessageType, productName?: string | null }> } | null } };

export type UpdateLineItemMutationVariables = Exact<{
  input: UpdateLineItemInput;
}>;


export type UpdateLineItemMutation = { __typename?: 'Mutation', updateLineItem?: { __typename?: 'UpdateLineItemResult', cart?: { __typename?: 'Cart', lineItems: Array<{ __typename?: 'LineItem', id: string, isQuantityEditable?: boolean | null, isDigital?: boolean | null, gaCode?: string | null, quantity: number, total?: { __typename?: 'Price', amount: number, currency: string } | null, totalShipping?: { __typename?: 'Price', amount: number, currency: string } | null, undiscountedTotal?: { __typename?: 'Price', amount: number, currency: string } | null, details: { __typename?: 'Details', options?: string | null, type?: string | null, imageUrl?: string | null, inventoryItemId?: string | null, blankItemId?: string | null, marketingProductTypeId?: string | null, marketingSku?: string | null, productTypeId?: string | null, productUrl?: string | null, price?: { __typename?: 'Price', amount: number, currency: string } | null }, work?: { __typename?: 'Work', id: string, title?: string | null, artistName?: string | null } | null }>, summary: { __typename?: 'Summary', showTaxSeparately: boolean, lineItemsCount: number, isTaxComputed: boolean, digitalProductsOnly: boolean, tax?: { __typename?: 'Tax', amount: number, currency: string, type: string } | null, total: { __typename?: 'Price', amount: number, currency: string }, subtotal: { __typename?: 'Price', amount: number, currency: string }, undiscountedSubtotal: { __typename?: 'Price', amount: number, currency: string }, shipping: { __typename?: 'Shipping', countryCode: string, countryName: string, estimated: { __typename?: 'EstimatedShipping', standard: { __typename?: 'PriceWithTax', amountExTax: number, price: { __typename?: 'Price', amount: number, currency: string }, tax: { __typename?: 'Tax', amount: number, currency: string, type: string } }, express?: { __typename?: 'PriceWithTax', amountExTax: number, price: { __typename?: 'Price', amount: number, currency: string }, tax: { __typename?: 'Tax', amount: number, currency: string, type: string } } | null }, selected: { __typename?: 'ShippingSelected', method: ShippingMethod, estimatedCost: { __typename?: 'PriceWithTax', amountExTax: number, price: { __typename?: 'Price', amount: number, currency: string }, tax: { __typename?: 'Tax', amount: number, currency: string, type: string } } }, totals: { __typename?: 'Totals', standard: { __typename?: 'Price', amount: number, currency: string }, express?: { __typename?: 'Price', amount: number, currency: string } | null } } }, appliedCoupon?: { __typename?: 'AppliedCoupon', code: string, type: CouponType, displayName: string, expiryDate: string, discount: { __typename?: 'Price', currency: string, amount: number } } | null, messages: Array<{ __typename?: 'Message', actionUrl?: string | null, applied: boolean, severity: MessageSeverity, text?: string | null, type: MessageType, productName?: string | null }> } | null, cartUserErrors: Array<{ __typename?: 'CartUserError', code: number, field: Array<string>, message?: string | null }> } | null };

export type UpdateShippingPreferenceMutationVariables = Exact<{
  input: ShippingPreferenceInput;
}>;


export type UpdateShippingPreferenceMutation = { __typename?: 'Mutation', updateShippingPreference: boolean };

export const CartFieldsFragmentDoc = gql`
    fragment CartFields on Cart {
  lineItems {
    id
    isQuantityEditable
    isDigital
    gaCode
    quantity
    total {
      amount
      currency
    }
    totalShipping {
      amount
      currency
    }
    undiscountedTotal {
      amount
      currency
    }
    details {
      options
      type
      imageUrl
      inventoryItemId
      blankItemId
      price {
        amount
        currency
      }
      marketingProductTypeId
      marketingSku
      productTypeId
      productUrl
    }
    work {
      id
      title
      artistName
    }
  }
  summary {
    showTaxSeparately
    lineItemsCount
    isTaxComputed
    tax {
      amount
      currency
      type
    }
    total {
      amount
      currency
    }
    subtotal {
      amount
      currency
    }
    undiscountedSubtotal {
      amount
      currency
    }
    shipping {
      countryCode
      countryName
      estimated {
        standard {
          price {
            amount
            currency
          }
          tax {
            amount
            currency
            type
          }
          amountExTax
        }
        express {
          price {
            amount
            currency
          }
          tax {
            amount
            currency
            type
          }
          amountExTax
        }
      }
      selected {
        estimatedCost {
          price {
            amount
            currency
          }
          tax {
            amount
            currency
            type
          }
          amountExTax
        }
        method
      }
      totals {
        standard {
          amount
          currency
        }
        express {
          amount
          currency
        }
      }
    }
    digitalProductsOnly
  }
  appliedCoupon {
    code
    type
    displayName
    discount {
      currency
      amount
    }
    expiryDate
  }
  messages {
    actionUrl
    applied
    severity
    text
    type
    productName
  }
}
    `;
export const CartUserErrorFieldsFragmentDoc = gql`
    fragment CartUserErrorFields on CartUserError {
  code
  field
  message
}
    `;
export const GetCartDocument = gql`
    query GetCart($shippingAddress: ShippingAddressInput) {
  cart(shippingAddress: $shippingAddress) {
    ...CartFields
  }
}
    ${CartFieldsFragmentDoc}`;

/**
 * __useGetCartQuery__
 *
 * To run a query within a React component, call `useGetCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartQuery({
 *   variables: {
 *      shippingAddress: // value for 'shippingAddress'
 *   },
 * });
 */
export function useGetCartQuery(baseOptions?: Apollo.QueryHookOptions<GetCartQuery, GetCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartQuery, GetCartQueryVariables>(GetCartDocument, options);
      }
export function useGetCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartQuery, GetCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartQuery, GetCartQueryVariables>(GetCartDocument, options);
        }
export function useGetCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartQuery, GetCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartQuery, GetCartQueryVariables>(GetCartDocument, options);
        }
export type GetCartQueryHookResult = ReturnType<typeof useGetCartQuery>;
export type GetCartLazyQueryHookResult = ReturnType<typeof useGetCartLazyQuery>;
export type GetCartSuspenseQueryHookResult = ReturnType<typeof useGetCartSuspenseQuery>;
export type GetCartQueryResult = Apollo.QueryResult<GetCartQuery, GetCartQueryVariables>;
export const GetDeliveryDatesDocument = gql`
    query GetDeliveryDates($countryCode: String!, $productTypeIds: String!, $timezoneOffset: String!) {
  deliveryDates(
    countryCode: $countryCode
    productTypeIds: $productTypeIds
    timezoneOffset: $timezoneOffset
  ) {
    standard {
      ... on DeliveryTimeFrame {
        earliest
        latest
      }
      ... on LastOrderByDate {
        targetDate
        daysLeft
      }
    }
    express {
      ... on DeliveryTimeFrame {
        earliest
        latest
      }
      ... on LastOrderByDate {
        targetDate
        daysLeft
      }
    }
  }
}
    `;

/**
 * __useGetDeliveryDatesQuery__
 *
 * To run a query within a React component, call `useGetDeliveryDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryDatesQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      productTypeIds: // value for 'productTypeIds'
 *      timezoneOffset: // value for 'timezoneOffset'
 *   },
 * });
 */
export function useGetDeliveryDatesQuery(baseOptions: Apollo.QueryHookOptions<GetDeliveryDatesQuery, GetDeliveryDatesQueryVariables> & ({ variables: GetDeliveryDatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveryDatesQuery, GetDeliveryDatesQueryVariables>(GetDeliveryDatesDocument, options);
      }
export function useGetDeliveryDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveryDatesQuery, GetDeliveryDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveryDatesQuery, GetDeliveryDatesQueryVariables>(GetDeliveryDatesDocument, options);
        }
export function useGetDeliveryDatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeliveryDatesQuery, GetDeliveryDatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeliveryDatesQuery, GetDeliveryDatesQueryVariables>(GetDeliveryDatesDocument, options);
        }
export type GetDeliveryDatesQueryHookResult = ReturnType<typeof useGetDeliveryDatesQuery>;
export type GetDeliveryDatesLazyQueryHookResult = ReturnType<typeof useGetDeliveryDatesLazyQuery>;
export type GetDeliveryDatesSuspenseQueryHookResult = ReturnType<typeof useGetDeliveryDatesSuspenseQuery>;
export type GetDeliveryDatesQueryResult = Apollo.QueryResult<GetDeliveryDatesQuery, GetDeliveryDatesQueryVariables>;
export const GetUserDocument = gql`
    query GetUser {
  user {
    assignedCoupons {
      autoApplied
      coupons {
        code
        type
        displayName
        expiryDate
      }
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const CouponCodeApplyDocument = gql`
    mutation CouponCodeApply($input: couponCodeApplyInput!) {
  couponCodeApply(input: $input) {
    cart {
      ...CartFields
    }
    cartUserErrors {
      ...CartUserErrorFields
    }
  }
}
    ${CartFieldsFragmentDoc}
${CartUserErrorFieldsFragmentDoc}`;
export type CouponCodeApplyMutationFn = Apollo.MutationFunction<CouponCodeApplyMutation, CouponCodeApplyMutationVariables>;

/**
 * __useCouponCodeApplyMutation__
 *
 * To run a mutation, you first call `useCouponCodeApplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCouponCodeApplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [couponCodeApplyMutation, { data, loading, error }] = useCouponCodeApplyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCouponCodeApplyMutation(baseOptions?: Apollo.MutationHookOptions<CouponCodeApplyMutation, CouponCodeApplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CouponCodeApplyMutation, CouponCodeApplyMutationVariables>(CouponCodeApplyDocument, options);
      }
export type CouponCodeApplyMutationHookResult = ReturnType<typeof useCouponCodeApplyMutation>;
export type CouponCodeApplyMutationResult = Apollo.MutationResult<CouponCodeApplyMutation>;
export type CouponCodeApplyMutationOptions = Apollo.BaseMutationOptions<CouponCodeApplyMutation, CouponCodeApplyMutationVariables>;
export const CouponCodeRemoveDocument = gql`
    mutation CouponCodeRemove {
  couponCodeRemove {
    cart {
      ...CartFields
    }
  }
}
    ${CartFieldsFragmentDoc}`;
export type CouponCodeRemoveMutationFn = Apollo.MutationFunction<CouponCodeRemoveMutation, CouponCodeRemoveMutationVariables>;

/**
 * __useCouponCodeRemoveMutation__
 *
 * To run a mutation, you first call `useCouponCodeRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCouponCodeRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [couponCodeRemoveMutation, { data, loading, error }] = useCouponCodeRemoveMutation({
 *   variables: {
 *   },
 * });
 */
export function useCouponCodeRemoveMutation(baseOptions?: Apollo.MutationHookOptions<CouponCodeRemoveMutation, CouponCodeRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CouponCodeRemoveMutation, CouponCodeRemoveMutationVariables>(CouponCodeRemoveDocument, options);
      }
export type CouponCodeRemoveMutationHookResult = ReturnType<typeof useCouponCodeRemoveMutation>;
export type CouponCodeRemoveMutationResult = Apollo.MutationResult<CouponCodeRemoveMutation>;
export type CouponCodeRemoveMutationOptions = Apollo.BaseMutationOptions<CouponCodeRemoveMutation, CouponCodeRemoveMutationVariables>;
export const UpdateLineItemDocument = gql`
    mutation UpdateLineItem($input: UpdateLineItemInput!) {
  updateLineItem(input: $input) {
    cart {
      ...CartFields
    }
    cartUserErrors {
      ...CartUserErrorFields
    }
  }
}
    ${CartFieldsFragmentDoc}
${CartUserErrorFieldsFragmentDoc}`;
export type UpdateLineItemMutationFn = Apollo.MutationFunction<UpdateLineItemMutation, UpdateLineItemMutationVariables>;

/**
 * __useUpdateLineItemMutation__
 *
 * To run a mutation, you first call `useUpdateLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLineItemMutation, { data, loading, error }] = useUpdateLineItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLineItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLineItemMutation, UpdateLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLineItemMutation, UpdateLineItemMutationVariables>(UpdateLineItemDocument, options);
      }
export type UpdateLineItemMutationHookResult = ReturnType<typeof useUpdateLineItemMutation>;
export type UpdateLineItemMutationResult = Apollo.MutationResult<UpdateLineItemMutation>;
export type UpdateLineItemMutationOptions = Apollo.BaseMutationOptions<UpdateLineItemMutation, UpdateLineItemMutationVariables>;
export const UpdateShippingPreferenceDocument = gql`
    mutation UpdateShippingPreference($input: ShippingPreferenceInput!) {
  updateShippingPreference(input: $input)
}
    `;
export type UpdateShippingPreferenceMutationFn = Apollo.MutationFunction<UpdateShippingPreferenceMutation, UpdateShippingPreferenceMutationVariables>;

/**
 * __useUpdateShippingPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateShippingPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShippingPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShippingPreferenceMutation, { data, loading, error }] = useUpdateShippingPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShippingPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShippingPreferenceMutation, UpdateShippingPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShippingPreferenceMutation, UpdateShippingPreferenceMutationVariables>(UpdateShippingPreferenceDocument, options);
      }
export type UpdateShippingPreferenceMutationHookResult = ReturnType<typeof useUpdateShippingPreferenceMutation>;
export type UpdateShippingPreferenceMutationResult = Apollo.MutationResult<UpdateShippingPreferenceMutation>;
export type UpdateShippingPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateShippingPreferenceMutation, UpdateShippingPreferenceMutationVariables>;